module.exports = __webpack_public_path__ + "static/LibreFranklin-Light-75d545c402fe2a73a053437baf3c06e7.ttf";